export default __webpack_public_path__ + "static/media/industry_grey.b5be6aaf.png";